export default __webpack_public_path__ + "static/media/cross.8bc50cca.svg";